import './App.css';
import { HeroSection } from './components/HeroSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ImpactSection } from './components/ImpactSection';
import { ProblemSection } from './components/ProblemSection';
import { SiteHeader } from './components/SiteHeader';
import { SolutionSection } from './components/SolutionSection';
import { ClosingCtaSection } from './components/ClosingCtaSection';

function App() {
  return (
    <div className="landing-page">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <SiteHeader />
      <main id="main-content" className="landing-page__main" tabIndex="-1">
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <HowItWorksSection />
        <ImpactSection />
        <ClosingCtaSection />
      </main>
    </div>
  );
}

export default App;
